import styled from 'styled-components';

import { CFG } from '../../../../../../theme/configurator-tokens';
import { cardHover } from '../../../../../../theme/configurator-keyframes';

export const Swatch = styled.button`
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  cursor: pointer;
  border: 0;
  padding: 0;
  background: transparent;
  /* Match the surface's rounding so the shared glow-border hover (cardHover) traces
     the swatch's rounded edge rather than a square. */
  border-radius: 20.6%;
  ${cardHover}
`;

/**
 * Surface tile. `$bg` comes from runtime data (the skin's own colour tokens), so it
 * is passed as a transient prop rather than a literal. The radius is a percentage
 * of the (square) swatch — pixel-equivalent to the old `size * 0.206`.
 */
export const Surface = styled.span<{ $bg: string }>`
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: ${(p) => p.$bg};
  border-radius: 20.6%;
`;

/** Bottom-right accent block — percentages lifted from Figma so it scales. */
export const Corner = styled.span<{ $bg: string }>`
  position: absolute;
  left: 31.9%;
  top: 41.4%;
  width: 87.4%;
  height: 81.5%;
  background: ${(p) => p.$bg};
  border-radius: 29%;
`;

export const Ring = styled.span`
  pointer-events: none;
  position: absolute;
  inset: -5px;
  /* Percentage radius (not a fixed px) so the ring stays concentric with the
     surface's 20.6% corners now the swatch scales to fill its column. */
  border-radius: 23%;
  border: 2px solid ${CFG.brand};
`;
